import gsap from 'gsap';
import imagesLoaded from 'imagesloaded';
import RytmWebflow from 'rytm-webflow'

const MAX_IMAGES_VISIBLE = 5;
const IMAGES_SCALE = .45;
const MIN_DISTANCE = 20;
const INITIAL_POSITIONS = [
  {x: .35, y: .4},
  {x: .5, y: .6},
  {x: .65, y: .5},
  {x: .55, y: .45},
];
const POS_RANDOM_X = 200;
const POS_RANDOM_Y = 140;

class ImagesController extends RytmWebflow.Controller {
  
  /**
  * on view Swap complete - just before SHOW
  * @param {Event} e
  **/
  onViewSwapComplete(e) {
    super.onViewSwapComplete(e);
    this.initImagesPlayground();
  }
  addEventListeners() {
    super.addEventListeners();
    if (this.isTouchScreenDevice()) {
      this.autoTimeout = setTimeout(this.startAutoRotate, 800);
    } else {
      document.documentElement.addEventListener("mousemove", this.onMouseMove);
    }
  }
  removeEventListeners() {
    super.removeEventListeners();
    if (this.isTouchScreenDevice()) {
      clearTimeout(this.autoTimeout);
      this.stopAutoRotate();
    } else {
      document.documentElement.removeEventListener("mousemove", this.onMouseMove);
    }
    this.destroyImagesPlayground();
  }
  // ### Custom ###
  // # Helpers #
  isTouchScreenDevice = () => {
    return 'ontouchstart' in window || navigator.msMaxTouchPoints;
  }
  // autorotate
  startAutoRotate = () => {
    this.autoRotateInterval = setInterval(() => {
      const centerX = window.innerWidth / 2;
      const centerY = window.innerHeight / 2;
      this.currentPoint = {x: centerX, y: centerY};
      const maxW = window.innerWidth / 3;
      const maxH = window.innerHeight / 4;
      const x = centerX + Math.random() * maxW - maxW / 2;
      const y = centerY + Math.random() * maxH - maxH / 2;
      this.placeImage(x, y, false);
    }, 200);
  }
  stopAutoRotate = () => {
    clearInterval(this.autoRotateInterval);
  }
  // # init
  initImagesPlayground = () => {
    if (this.imagesReady) return;
    this.images = [];
    this.index = 0;
    this.currentPoint = {x: 0, y: 0};
    const container = document.querySelector(this.getContainerSelector());
    imagesLoaded(container, { background: true}, (instance) => {
      this.initialImages();
    });
  }
  // # destroy
  destroyImagesPlayground = () => {
    if (!this.imagesReady) return;
    this.imagesReady = false;
    this.images = [];
    this.index = 0;
    this.currentPoint = {x: 0, y: 0};
  }
  // initial images
  initialImages = () => {
    const wW = window.innerWidth;
    const wH = window.innerHeight;
    INITIAL_POSITIONS.forEach(pos => {
      this.placeImage(wW * pos.x, wH * pos.y, true);
    });
  }

  // ### Event listeners ###
  onMouseMove = (e) => {
    if (!this.imagesReady) return;
    const { clientX, clientY } = e;
    this.placeImage(clientX, clientY);
  }
  // Place image on x, y
  placeImage = (x, y, animate = false) => {
    const dist = Math.sqrt((this.currentPoint.x - x) ** 2 + (this.currentPoint.y - y) ** 2);
    if (dist < MIN_DISTANCE) return;
    this.currentPoint = {x, y};
    const image = this.getImage();
    if (!image) return;
    const container = document.querySelector(this.getContainerSelector());
    const wrapper = container.querySelector(".images-wrapper");
    if (!wrapper) {
      return;
    }
    const halfW = window.innerWidth / 2;
    const halfH = window.innerHeight / 2;
    const copy = image.cloneNode(true);
    copy.classList.add("item-image-md--copy");
    const randomX = Math.random() * POS_RANDOM_X - POS_RANDOM_X / 2;
    const randomY = Math.random() * POS_RANDOM_Y - POS_RANDOM_Y / 2;
    const posX = x - halfW + randomX;
    const posY = y - halfH + randomY;
    const startX = x > halfW ? window.innerWidth + halfW : -halfW * 2;
    const startY = y > halfH ? window.innerHeight + halfH : -halfH * 2;
    gsap.set(copy, { 
      x: animate ? startX : posX,
      y: animate? startY : posY, 
      scale: IMAGES_SCALE,
    });
    if (animate) {
      gsap.to(copy, { 
        x: posX,
        y: posY,
        duration: 1, 
        delay: .4,
        ease: 'power3.out',
        onComplete: () => {
          this.imagesReady = true;
        }
      });
    }
    this.images.push(copy);
    let newImages = [];
    let cc = 0;
    for (let i = this.images.length - 1; i >= 0; i--) {
      const currentImg = this.images[cc];
      cc++;
      currentImg.style.zIndex = this.images.length - i + 5;
      if (i >= MAX_IMAGES_VISIBLE) {
        wrapper.removeChild(currentImg);
      } else {
        newImages.push(currentImg);
      }
    }
    this.images = newImages;
    wrapper.appendChild(copy);

    
  }
  getImage = () => {
    const list = this.getImages();
    if (!list.length) return;
    const img = list[this.index];
    this.index = (this.index + 1);
    if (this.index >= list.length) this.index = 0;
    return img;
  }
  getImages = () => {
    const container = document.querySelector(this.getContainerSelector());
    const imagesData = container.querySelector(".images-data");
    return imagesData ? imagesData.querySelectorAll(".item-image-md") : [];
  }

}

export default ImagesController;